import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  signal,
  ViewChildren
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../data/pipes/translate.pipe';

export interface ToggleOption {
  label: string;
  value: number | string;
}

@Component({
  selector: 'app-toggle',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
})
export class ToggleComponent implements AfterViewChecked {
  @Input() color!: string;
  @Input() options: ToggleOption[] = [];
  @Output() optionSelected = new EventEmitter<ToggleOption>();

  @ViewChildren('toggleOption') toggleOptions!: QueryList<ElementRef>;

  selectedOptionIndexSignal = signal<number>(0);
  sliderStyle = {};

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    this.adjustSliderPosition();
    this.changeDetectorRef.detectChanges();
  }

  selectOption(index: number): void {
    this.selectedOptionIndexSignal.set(index);
    this.adjustSliderPosition();
    this.optionSelected.emit(this.options[index]);
  }

  private adjustSliderPosition(): void {
    const activeOption = this.toggleOptions.find((_, index) => index === this.selectedOptionIndexSignal());

    if (activeOption) {
      const { offsetLeft, offsetWidth } = activeOption.nativeElement;
      this.sliderStyle = {
        width: `${offsetWidth}px`,
        transform: `translateX(${offsetLeft}px)`
      };
    }
  }
}

